import React, { Suspense } from 'react'

const DashboardPageBase = React.lazy(() => import('./Dashboard'))

export const DashboardPage = () => (
  <Suspense fallback={null}>
    <DashboardPageBase />
  </Suspense>
)
